import GridTableComponent from '../common/GridTableComponent/gridTableTemplate';
import React, { useEffect, useRef, useState } from 'react';
import styles from '../Information/Information.module.scss';
import { Box, Grid, FormControl, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import toast from 'react-hot-toast';
import { apiRequest, catchErrorMessageHandler } from '../../infrastructure/backendService';
import ToastError from '../common/toast/toastError';
import { CustomInputLabel, CustomMenuItem, CustomSelect } from '../common/StyledComponents/StyledFields';
import apiPath from '../../config/apiPaths.json';
import { isNil } from 'lodash';
import ErrorPopup from '../common/ErrorPopup';
import constants from "../../config/constants.json";

const MangementTeam = () => {
   const tableRef = useRef(null);
   const [isOpen, setIsOpen] = useState<boolean>(false);
   const currentYear = new Date().getFullYear();
   const [selectedYear, setSelectedYear] = useState(`${currentYear}-${currentYear + 1}`);
   const [yearslist, setyearsList] = useState([]);
   const [tablelist, setTablelist] = useState([]);
   const [bodItemsData, setBodItemsData] = useState<any[]>([]);
   const [ecTablelist, setEcTablelist] = useState([]);

   useEffect(() => {
      apiRequest({
         method: 'GET',
         endpoint: apiPath.pastManagementYearsList,
         includeToken: true
      })
         .then((res) => {
            console.log(res.data);
            setyearsList(res.data);
         })
         .catch((err) => {
            console.log(err);
            toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
               duration: constants.TOAST_POPUP_DURATION,
             });
         });
   }, []);


   useEffect(() => {
      apiRequest({
         method: 'GET',
         endpoint: apiPath.pastManagementsByYear,
         includeToken: true,
         params: {
            yearFrom: selectedYear,
            category: "BOD"
         }
      })
         .then((res) => {
            console.log(res.data, "BODDDDDDDDDDDD");
            setBodItemsData(res.data);
         })
         .catch((err) => {
            console.log(err);
            toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
               duration: constants.TOAST_POPUP_DURATION,
             });
         });
   }, [selectedYear]);
   useEffect(() => {
      apiRequest({
         method: 'GET',
         endpoint: apiPath.pastManagementsByYear,
         includeToken: true,
         params: {
            yearFrom: selectedYear,
            category: "EC"
         }
      })
         .then((res) => {
            console.log(res.data, "ECCCCCCCCCCCCCCCCC");
            setEcTablelist(res.data);
         })
         .catch((err) => {
            console.log(err);
          
            toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
               duration: constants.TOAST_POPUP_DURATION,
             });
         });
   }, [selectedYear]);


   const handleYearChange = (event: any) => {
      setSelectedYear(event.target.value);
   };
   const ManagementTeamDropdown = (): React.ReactElement => {
      const currentYear = new Date().getFullYear();
      return (
         <FormControl sx={{ paddingBottom: '24px', width: '327px' }}>
            <CustomSelect
               sx={{border: "1px solid rgba(136, 46, 20, 0.4)" }}
               IconComponent={KeyboardArrowDownIcon}
               defaultValue={currentYear.toString()}
               id="grouped-select"
               onChange={handleYearChange}
               value={selectedYear}
               MenuProps={{
                  PaperProps: {
                     sx: {
                        border: '1px solid #F05802',
                        '& ul': {
                           paddingTop: 0,
                           paddingBottom: 0,
                           overflowY: 'auto',
                           minHeight: 'auto',
                           maxHeight: '300px',
                           '&::-webkit-scrollbar': {
                              width: '8px',
                           },
                           '&::-webkit-scrollbar-thumb': {
                              background: '#F3C539',
                              borderRadius: '6px',
                           },
                        },
                     },
                  },
               }}
            >
               {yearslist.map((item, i) => (
                  <CustomMenuItem value={item} key={i}>
                     {item}
                  </CustomMenuItem>
               ))}
            </CustomSelect>
         </FormControl>
      );
   };

   return (
      <Box className={styles.ManagemnetTeamTotalLayout}>
         <Typography className={styles.mainHeading}>Management Team</Typography>
         <Box className={styles.ManagementTeamDetails}>
            <CustomInputLabel>Select year</CustomInputLabel>
            {ManagementTeamDropdown()}
            <div className={styles.mainContainer}>
                  <div className={styles.tableWrapper}>
                     <table className={styles.tableContainers}>
                        <thead>
                           <tr className={styles.headerTableRow}>
                              <th className={styles.tableHorizontal}>Board Of Directors</th>
                              <th className={styles.tableHorizontal}>Committee</th>
                           </tr>
                        </thead>
                        <tbody>
                           {bodItemsData.map((item, index) => (
                              <tr key={index} className={styles.tableRow}>
                                 <td className={styles.tableDiagonal}>
                                       {item.fullName}
                                 </td>
                                 <td className={styles.tableDiagonal}>{item.committee}</td>
                              </tr>
                           ))}
                        </tbody>
                     </table>
                  </div>
                  <div className={styles.tableWrapper}>
                     <table className={styles.tableContainers}>
                        <thead>
                           <tr className={styles.headerTableRow}>
                              <th className={styles.tableHorizontal}>Executive Commitee Members</th>
                              <th className={styles.tableHorizontal}>Committee</th>
                           </tr>
                        </thead>
                        <tbody>
                           {ecTablelist.map((item: any, index) => (
                              <tr key={index} className={styles.tableRow}>
                                 <td className={styles.tableDiagonal}>
                                       {item.fullName}
                                 </td>
                                 <td className={styles.tableDiagonal}>{item.committee}</td>
                              </tr>
                           ))}
                        </tbody>
                     </table>
                  </div>
            </div>
         </Box>
      </Box>
   );
};

export default MangementTeam;
